import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { DocumentTypes } from 'builder/modules/constants'
import { AIRefreshStatus, actions, selectors } from 'builder/modules/panel'

import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useResumeStatusPolling } from 'builder/components/Panel/Document/AiRefresher/hooks/useResumeStatusPolling'

export const useOnboarding = () => {
  const dispatch = useDispatch()
  const resumes = useTypedSelector(store => selectors.documentsByType(store, DocumentTypes.resume))
  const aiResume = resumes.find(resume => resume.aiJobStatus)

  const isAiResumePending = !aiResume || aiResume?.aiJobStatus === AIRefreshStatus.PENDING
  const isAiResumeSuccess = aiResume?.aiJobStatus === AIRefreshStatus.SUCCESS
  const isAiResumeFailed = aiResume?.aiJobStatus === AIRefreshStatus.FAILURE

  useResumeStatusPolling(aiResume?.id || 0)

  useEffect(() => {
    dispatch(actions.fetchDocuments())
  }, [dispatch])

  return {
    resume: isAiResumeSuccess ? aiResume : undefined,
    isAiResumePending,
    isAiResumeSuccess,
    isAiResumeFailed,
  }
}
